import type { SacramentStatus as PSacramentStatus } from 'generated/prisma/enums';

export const SacramentStatuses: Record<keyof typeof PSacramentStatus, string> = {
  BOTH: 'Ambos',
  NONE: 'Nenhum',
  ONLY_ONE: 'Somente um',
};
